class LWHamburger extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.isOpen = false;
        this.onKeyDown = (event) => this.handleKey(event);
    }

    connectedCallback() {
        const engels = document.documentElement.lang === 'en';
        this.labels = {
            open: engels ? 'Menu' : 'Menu',
            close: engels ? 'Close menu' : 'Sluit menu',
        };

        this.render();

        if (this.hasAttribute('target')) {
            this.targetMenu = document.getElementById(this.getAttribute('target'));
        }

        if (this.parentElement && this.parentElement !== document.body) {
            document.body.appendChild(this);
        }

        document.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeyDown);
    }

    toggleMenu(open) {
        this.isOpen = typeof open === 'boolean' ? open : !this.isOpen;
        const button = this.shadowRoot.querySelector('button');
        button.classList.toggle('open', this.isOpen);
        button.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
        button.querySelector('.label').textContent = this.isOpen ? this.labels.close : this.labels.open;

        if (!this.targetMenu) {
            return;
        }

        if (this.isOpen) {
            this.zetAchtergrond(true);
            this.targetMenu.setAttribute('open', '');
            const eerste = this.targetMenu.querySelector('lw-inhoud');
            eerste?.shadowRoot?.querySelector('a')?.focus();
            return;
        }

        this.targetMenu.removeAttribute('open');
        this.zetAchtergrond(false);
        button.focus();
    }

    zetAchtergrond(verberg) {
        const elementen = [...document.body.children].filter((element) => {
            return element !== this && element !== this.targetMenu;
        });

        elementen.forEach((element) => {
            element.inert = verberg;
        });
    }

    handleKey(event) {
        if (!this.isOpen) {
            return;
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            this.toggleMenu(false);
            return;
        }

        if (event.key !== 'Tab' || !this.targetMenu) {
            return;
        }

        const items = [...this.targetMenu.querySelectorAll('lw-inhoud')];
        const eerste = items[0];
        const button = this.shadowRoot.querySelector('button');
        const actief = document.activeElement;

        if (!event.shiftKey && actief === this) {
            event.preventDefault();
            eerste?.shadowRoot?.querySelector('a')?.focus();
        }

        if (event.shiftKey && actief === eerste) {
            event.preventDefault();
            button.focus();
        }
    }

    render() {
        const target = this.getAttribute('target') || '';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                position: fixed !important;
                top: 40px;
                right: 40px;
                z-index: 10001;
                display: block !important;
            }

            button {
                position: relative;
                width: 44px;
                height: 44px;
                padding: 12px 10px;
                border: 0;
                background: #161616;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                cursor: pointer;
            }

            button:focus-visible {
                outline: 3px solid #fff;
                outline-offset: 3px;
            }

            .line {
                width: 100%;
                height: 3px;
                background-color: #fff;
                display: block;
                transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
            }

            .label {
                position: absolute;
                width: 1px;
                height: 1px;
                overflow: hidden;
                clip: rect(0, 0, 0, 0);
            }

            .open .line:nth-child(1) { transform: translateY(8.5px) rotate(45deg); }
            .open .line:nth-child(2) { opacity: 0; }
            .open .line:nth-child(3) { transform: translateY(-8.5px) rotate(-45deg); }

            @media (max-width: 767px) {
                :host {
                    top: 20px;
                    right: 20px;
                    left: auto;
                }
            }

            @media (min-width: 768px) {
                button {
                    display: none;
                }
            }

            @media (prefers-reduced-motion: reduce) {
                .line {
                    transition: none;
                }
            }
        </style>
        <button type="button" class="hamburger" aria-expanded="false" aria-controls="${target}">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
            <span class="label">${this.labels.open}</span>
        </button>
        `;

        this.shadowRoot.querySelector('button').addEventListener('click', () => this.toggleMenu());
    }
}

customElements.define('lw-hamburger', LWHamburger);
